export enum ProcedureTypeEnum {
  AUTHORIZE = "AUTHORIZE",
  CERTIFY = "CERTIFY",
}

export const ProcedureTypeMapper = {
  [ProcedureTypeEnum.AUTHORIZE]: "Autorización de documento",
  [ProcedureTypeEnum.CERTIFY]: "Certificación de documento",
};
